export default __webpack_public_path__ + "static/vision-cube-28cabcc222adee51407bc294b6bdbec9.png";